import { render, staticRenderFns } from "./wszl.vue?vue&type=template&id=6c3af87e&scoped=true&"
import script from "./wszl.vue?vue&type=script&lang=js&"
export * from "./wszl.vue?vue&type=script&lang=js&"
import style0 from "./wszl.vue?vue&type=style&index=0&id=6c3af87e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3af87e",
  null
  
)

export default component.exports